<div class="access-denied" *ngIf="!isSuperAdmin">
  <mat-icon class="access-denied-icon">lock</mat-icon>
  <h3>{{ 'configurations.partners.accessDenied.title' | translate }}</h3>
  <p>{{ 'configurations.partners.accessDenied.description' | translate }}</p>
</div>

<div class="admin-create-partner" *ngIf="isSuperAdmin">
  <h1 class="page-title">{{ 'configurations.partners.title' | translate }}</h1>

  <div class="warn-box">
    <mat-icon>warning</mat-icon>
    <span>{{ 'configurations.partners.warning' | translate }}</span>
  </div>

  <form [formGroup]="partnerForm" (ngSubmit)="submit()">
    <section class="form-section">
      <h2 class="section-title">{{ 'configurations.partners.generalInfo' | translate }}</h2>
      <div class="form-grid">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'configurations.partners.companyName' | translate }}</mat-label>
          <input matInput formControlName="name_partner" required>
          <mat-error *ngIf="partnerForm.controls['name_partner'].hasError('required')">
            {{ 'configurations.partners.required' | translate }}
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ 'configurations.partners.address' | translate }}</mat-label>
          <input matInput formControlName="adress_partner" required>
          <mat-error *ngIf="partnerForm.controls['adress_partner'].hasError('required')">
            {{ 'configurations.partners.required' | translate }}
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ 'configurations.partners.country' | translate }}</mat-label>
          <mat-select formControlName="country" (selectionChange)="onCountryChange($event.value)" required>
            <mat-option *ngFor="let country of countries" [value]="country.id">
              {{ country.name_country }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="partnerForm.controls['country'].hasError('required')">
            {{ 'configurations.partners.required' | translate }}
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ 'configurations.partners.city' | translate }}</mat-label>
          <mat-select formControlName="city" required>
            <mat-option *ngFor="let city of cities" [value]="city.id">{{ city.name_city }}</mat-option>
          </mat-select>
          <mat-error *ngIf="partnerForm.controls['city'].hasError('required')">
            {{ 'configurations.partners.required' | translate }}
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ 'configurations.partners.currency' | translate }}</mat-label>
          <mat-select formControlName="currency_id" required>
            <mat-option *ngFor="let currency of currencies" [value]="currency.id">
              {{ currency.codeCurrency }} - {{ currency.nameCurrency }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="partnerForm.controls['currency_id'].hasError('required')">
            {{ 'configurations.partners.required' | translate }}
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ 'configurations.partners.serviceName' | translate }}</mat-label>
          <input matInput formControlName="name_portal" required>
          <mat-error *ngIf="partnerForm.controls['name_portal'].hasError('required')">
            {{ 'configurations.partners.required' | translate }}
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ 'configurations.partners.phone' | translate }}</mat-label>
          <input matInput formControlName="phone_partner" required>
          <mat-error *ngIf="partnerForm.controls['phone_partner'].hasError('required')">
            {{ 'configurations.partners.required' | translate }}
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ 'configurations.partners.chargeOverdue' | translate }}</mat-label>
          <mat-select formControlName="acummulate_debt" required>
            <mat-option [value]="true">{{ 'configurations.partners.yes' | translate }}</mat-option>
            <mat-option [value]="false">{{ 'configurations.partners.no' | translate }}</mat-option>
          </mat-select>
          <mat-error *ngIf="partnerForm.controls['acummulate_debt'].hasError('required')">
            {{ 'configurations.partners.required' | translate }}
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ 'configurations.partners.emailNotif' | translate }}</mat-label>
          <mat-select formControlName="create_email_notification" required>
            <mat-option [value]="true">{{ 'configurations.partners.yes' | translate }}</mat-option>
            <mat-option [value]="false">{{ 'configurations.partners.no' | translate }}</mat-option>
          </mat-select>
          <mat-error *ngIf="partnerForm.controls['create_email_notification'].hasError('required')">
            {{ 'configurations.partners.required' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
    </section>

    <section class="form-section">
      <h2 class="section-title">{{ 'configurations.partners.processingAccount' | translate }}</h2>
      <div class="form-grid">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'configurations.partners.bankAccount' | translate }}</mat-label>
          <mat-select formControlName="bank" required>
            <mat-option *ngFor="let bank of banks" [value]="bank.id">{{ bank.name }}</mat-option>
          </mat-select>
          <mat-error *ngIf="partnerForm.controls['bank'].hasError('required')">
            {{ 'configurations.partners.required' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
    </section>

    <section class="form-section">
      <h2 class="section-title">{{ 'configurations.partners.platformAccess' | translate }}</h2>
      <div class="form-grid">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'configurations.partners.accessEmail' | translate }}</mat-label>
          <input matInput type="email" formControlName="access_email">
          <mat-hint>{{ 'configurations.partners.accessEmailHelp' | translate }}</mat-hint>
          <mat-error *ngIf="partnerForm.controls['access_email'].hasError('required')">
            {{ 'configurations.partners.required' | translate }}
          </mat-error>
          <mat-error *ngIf="partnerForm.controls['access_email'].hasError('email')">
            {{ 'configurations.partners.invalidEmail' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
    </section>

    <div class="actions">
      <button type="button" mat-stroked-button (click)="goBack()">
        {{ 'configurations.buttons.back' | translate }}
      </button>
      <button type="submit" mat-flat-button color="primary">
        {{ 'configurations.partners.createButton' | translate }}
      </button>
    </div>
  </form>
</div>
